module.exports = __webpack_public_path__ + "img/banner_lowAltitude.13a9f942.jpg";